import * as Sentry from '@sentry/browser';
import { Status, States } from '@sift/resift/models/Status';
import { setStatus } from 'store/themes/actions/setStatus';
import { fetchThemes } from 'store/themes/actions/getThemes';

import fetchWithAuth from 'store/_helpers/fetchWithAuth';
import createTheme from 'store/themes/actions/_helpers/createTheme';

async function createAndUploadTheme(theme) {
  // have to convert these to S3 URLs by uploading theme to S3
  const { logoUrl, pictureUrl, backgroundUrl, settings = {} } = theme;

  const newTheme = await createTheme({ settings, logoUrl, pictureUrl, backgroundUrl });
  if (!newTheme) return;
  const themeId = newTheme.id;

  // active theme
  await fetchWithAuth(`/api/themes/${themeId}/activate`, {
    method: 'POST',
  });
}

async function deactivateTheme(themeId) {
  await fetchWithAuth(`/api/themes/${themeId}/deactivate`, { method: 'POST' });
}

export function saveTheme(_theme) {
  // remove props from a possible existing theme
  const { mode, createdAt, clientId, updatedAt, id, isActive, ...theme } = _theme;

  // return a thunk and depending on the mode, create or destroy a theme
  return async dispatch => {
    try {
      dispatch(setStatus(new Status(States.LOADING)));

      if (mode === 'custom') {
        await createAndUploadTheme(theme);
      } else {
        await deactivateTheme(id);
      }

      dispatch(setStatus(new Status(States.NORMAL)));
      dispatch(fetchThemes());
    } catch (e) {
      Sentry.captureException(e);
      dispatch(setStatus(new Status(States.ERROR)));
      // eslint-disable-next-line
      console.error(e);
    }
  };
}
